import checkTypeValidity from '../type-check/check-type-validity.js';

/**
 * @func removeProps
 * @param {object} object - object to examine.
 * @param {array} values - values to remove.
 * @return {object}
 * @desc Removes object properties that match a given value
 * ```js
 * removeProps({ age: 40, name: undefined }, [undefined]);
 * // returns { age: 40 }
 * ```
 * @memberof module:Object
 * @instance
 */
function removeProps(object, values) {
    if (!checkTypeValidity(['object'], object))
        return object;
    if (!checkTypeValidity(['array'], values))
        return object;
    return Object.keys(object)
        .filter(field => !values.includes(object[field]))
        .reduce((hash, field) => (Object.assign(Object.assign({}, hash), { [field]: object[field] })), {});
}

export { removeProps as default };
